// import SignInPage from './SignInPage';
import authRoles from '../../auth/authRoles';
import SignInWithMyId from './SignInWithMyId';
import { lazy } from 'react';

const signInPath = process.env.REACT_APP_LOGIN_PAGE_FOLDER || '';
const SignInPage = lazy(() => import(`./${signInPath}SignInPage`));

const SignInConfig = {
  settings: {
    layout: {
      config: {
        navbar: {
          display: false,
        },
        toolbar: {
          display: false,
        },
        footer: {
          display: false,
        },
        leftSidePanel: {
          display: false,
        },
        rightSidePanel: {
          display: false,
        },
      },
    },
  },
  auth: authRoles.onlyGuest,
  routes: [
    {
      path: 'sign-in',
      element: <SignInPage />,
    },
    {
      path: 'sign-in-with-myid',
      element: <SignInWithMyId />,
    },
  ],
};

export default SignInConfig;
